import React, { useState, useEffect, useMemo, useRef } from "react";
import { mapProperties } from "colbi_web_ui/lib/utils";
import {
    filteredQueriesByModules,
    filteredQueriesByModulesForMenu,
    getFirstModuleOfArray,
} from "../../routes/manageRouting";
import { hydrateRoute, urlRedirectLink } from "../../utils/routingUtils";
import { BuildSovosNavProps, decodeUserSession, GLOBAL_HEADER_HEIGHT, hasModule } from "../../utils/utils";
import LoadingPage from "../Login/LoadingPage";
import GlobalLayout from "../../components/GlobalLayout/GlobalLayout";
import {
    SovosBox,
    SovosCircularProgress,
    SovosPageContentGeneric,
    SovosPageLayout,
    SovosTypography,
    SovosDivider,
} from "mosaic-react";
import { RepositoryStatus } from "../../components";
import FileInformationSelection from "colbi_web_ui/lib/components/layout/FileInformationSelection/FileInformationSelection";
import Connect from "colbi_web_ui/lib/components/Connect";
import { LoadingIndicator } from "colbi_web_ui/lib/components";
import MainTabs from "../App/MainTabs/MainTabs";
import { renderRoutes } from "react-router-config";
import { useAuth } from "react-oidc-context";
import I18n from "../../I18n";

import { mapPropertiesForMenu } from "../../utils";
import { dedupeHydratedOverviewStaticLinks } from "../../utils/filterOverviewMenuForNewNavigation";
import { parse } from "query-string";
import { filteredNavigationByModulesForNestedLinks } from "../Repository/navigation";
import { MainMenuContent } from "../../components/MainMenuContent/MainMenuContent";
import { StackedLineChart } from "mosaic-react-icons";
import { useLocation } from "react-router";
/**
 * Controller folder utils
 * Built to make controller code less repeatable and lex complex to understand
 * */

// similar to getQueryResults but for array of queryNames
export const getQueryResultsArray = (fetchResults, queryNamesArray) => {
    return queryNamesArray.reduce((acc, { resultName, queryName }) => {
        acc[resultName] = fetchResults[queryName];
        return acc;
    }, {});
};

export const userSessionInfo = (user) => decodeUserSession(user);

export const appRedirectValidations = (params) => {
    const {
        redirect,
        projectId,
        locale,
        fiscalYear,
        importId,
        fiscalYears,
        appContext,
        match,
        matchParams,
        importIdToUse,
        firstModuleFromProject,
        section,
        fileType,
    } = params || {};

    if (redirect) {
        return redirect;
    }

    if (!projectId) {
        return urlRedirectLink(`${locale ? `/${locale}` : ""}/`);
    }

    if (!fiscalYear && !importId && !fiscalYears.length) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/0000/full/repository/activity`,
        );
    }

    if (
        fiscalYear &&
        importId &&
        fiscalYears.length &&
        appContext === "repository" &&
        !(match?.url || "").match("\\d+/\\d+/\\d+/repository") &&
        !(match?.url || "").match("\\d+/\\d+/full/repository")
    ) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/${fiscalYear}/${importId}/repository/${section}${fileType ? "/" + fileType : ""}`,
        );
    }

    if (fiscalYear === "0000" && fiscalYears.length && !(match?.url || "").includes("column_mapping")) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear: String(Math.max(...fiscalYears)).padStart(4, "0"),
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }

    if (
        fiscalYear &&
        importIdToUse &&
        !isNaN(Number(matchParams.fiscalYear)) &&
        !isNaN(Number(matchParams.importId)) &&
        fiscalYear !== matchParams.fiscalYear &&
        importIdToUse !== matchParams.importId &&
        firstModuleFromProject
    ) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear,
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }
};

export const repoRedirectValidations = (params) => {
    const {
        redirect,
        fiscalYear,
        importId,
        fiscalYears,
        appContext,
        match,
        matchParams,
        importIdToUse,
        firstModuleFromProject,
        section,
        fileType,
        queryStatus,
        setAccount,
        project,
        locale,
        history,
        proxy,
        projectId,
    } = params || {};

    if (redirect) {
        return redirect;
    }

    if (match?.params?.urlRedir && (!queryStatus || queryStatus?.loading)) {
        return <LoadingPage />;
    }

    if (fiscalYear && fiscalYear !== "0000" && match?.params?.urlRedir) {
        return setAccount(project, locale, history, proxy, params);
    }

    if (!section) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/0000/full/repository/activity`,
        );
    }

    if (!projectId) {
        return urlRedirectLink(`${locale ? `/${locale}` : ""}/`);
    }

    if (!fiscalYear && !importId && !fiscalYears.length) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/0000/full/repository/activity`,
        );
    }

    if (
        fiscalYear &&
        importId &&
        fiscalYears.length &&
        appContext === "repository" &&
        !(match?.url || "").match("\\d+/\\d+/\\d+/repository") &&
        !(match?.url || "").match("\\d+/\\d+/full/repository")
    ) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/${fiscalYear}/${importId}/repository/${section}${fileType ? "/" + fileType : ""}`,
        );
    }

    if (fiscalYear === "0000" && fiscalYears.length && !(match?.url || "").includes("column_mapping")) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear: String(Math.max(...fiscalYears)).padStart(4, "0"),
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }

    if (
        fiscalYear &&
        importIdToUse &&
        !isNaN(Number(matchParams.fiscalYear)) &&
        !isNaN(Number(matchParams.importId)) &&
        fiscalYear !== matchParams.fiscalYear &&
        importIdToUse !== matchParams.importId &&
        firstModuleFromProject
    ) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear,
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }
};

export const controllerQueries = (args, userModulesByProject, extraQueries = undefined) => {
    const queries = filteredQueriesByModules(userModulesByProject);
    const deepCopyQueries = JSON.parse(JSON.stringify(queries));
    if (deepCopyQueries) {
        //needed to change arguments to the respective value
        deepCopyQueries.forEach((query) =>
            Object.keys(query.args).forEach((k) =>
                query.args[k] ? query.args[k] : (query.args[k] = args[k] || query.args[k]),
            ),
        );
    }

    const allQueries = [
        {
            resource: "menu_organizations_projects",

            body: "id,name,typeEntity,nestedAccounts{id,name,typeEntity}",
            forceRefresh: true,
        },
        {
            resource: "organization_projects_by_projectId",
            args: {
                projectId: args.projectId,
                viewMode: args.viewMode || "",
            },
            body: "id,name,maxFiscalYear,fiscalYears,calendarYears,mosaicThemeConfig,projects{id,name,fiscalYears,status,taxRegistrationNumber,active,projectExpired,metadata,mosaicThemeConfig,modules{navigation_by_import_id,name,default_route,default_module}},organizationExpired, organizationActive, maxFiscalYear",
            forceRefresh: true,
        },
        {
            resource: "get_limit_export",
        },
        {
            resource: "file_types_modules",
            args: {
                projectId: args.projectId,
            },
            body: "id, name, configSet, viewMode",
            forceRefresh: true,
        },
        {
            resource: "data_files_types_present",
            args: {
                projectId: args.projectId,
            },
            forceRefresh: true,
            body: "hasSource, hasLegal",
        },
        {
            resource: "file_types_modules_by_project",
            args: {
                projectId: args.projectId,
            },
            forceRefresh: true,
            body: "id, name, configSet, viewMode",
        },
        ...(extraQueries?.length ? extraQueries : []),
        ...deepCopyQueries,
    ].filter((query) => query);

    if (userModulesByProject && userModulesByProject.includes("merge_collisions")) {
        allQueries.push({
            resource: "repository_status",
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                viewMode: args.viewMode || "",
            },
            body: "repoStatus,fiscalYear,fileType,autoMerge",
        });
    }
    return allQueries;
};

export const generateChildren = ({
    displayComponents,
    fetchResults,
    fetchStatus,
    routeQueries,
    props,
    params,
    i18n,
    locale,
    modules,
    fetch,
    pushModal,
    reload,
    onClickConfigurator,
}) => {
    return displayComponents.map((c, index) => {
        const Component = c.component;
        const componentParsedProps = mapProperties(
            c.props,
            fetchResults,
            fetchStatus,
            routeQueries,
            props,
            params,
            i18n,
            locale,
        );

        const componentProps = {
            ...componentParsedProps,
            modules,
        };

        if (componentProps && componentProps.onClickPushModal) {
            onClickConfigurator(componentProps, params, pushModal, i18n, reload);
        }

        return (
            <Component
                key={index}
                modifiers={c.modifiers}
                {...componentProps}
                activity={fetch.activity}
            />
        );
    });
};

export const onClickConfiguratorApp = (componentProps, params, pushModal, i18n, reload) => {
    const { view, title } = componentProps.onClickPushModal;
    componentProps.onRowClickCustom = (e) => {
        const { row } = e;
        pushModal({
            title: i18n`${title}`,
            data: {
                projectId: params.projectId,
                ...row,
            },
            args: { ...params, ...row },
            view: `${view}Form`,
        })
            .then(() => reload && reload())
            .catch(() => null);
    };
};

export const onClickConfiguratorRepository = (componentProps, params, pushModal, i18n, reload) => {
    const { view, title } = componentProps.onClickPushModal;
    componentProps.onClick = (e) => {
        e.originalEvent.preventDefault();
        e.originalEvent.stopPropagation();
        const data = e.target.value || {};
        pushModal({
            title: i18n`${title}`,
            data: {
                projectId: params.projectId,
                ...data,
            },
            args: { ...params, ...data },
            view: `${view}Form`,
        })
            .then(() => reload && reload())
            .catch(() => null);
    };
};

export const isPageLoading = (status, activity) => {
    return (
        activity ||
        activity === null ||
        Object.keys(status).some((queryKey) => {
            return status[queryKey].loading === true;
        })
    );
};

export const GlobalPageLayout = ({
    styles = {},
    globalLayoutProps,
    modules,
    headerProps,
    headerComponentsMapper,
    children,
    route,
    matchParams,
    fetch,
    isLoadingContent,
    history,
    i18n,
    menuEntries
}) => {
    const hasNewNavigation = hasModule(modules, "new_navigation");
    const { params, leftMenuStaticLinks, repositoryStatus, hasHeroBanner } = globalLayoutProps;
    const { entitiesMenu } = params || {};
    const { title, titleBarActions, customHeader, ...restHeaderProps } = headerProps;
    const hasCustomHeader = !!customHeader;
    const [showMainMenu, setShowMainMenu] = useState(false);
    const [topOffset, setTopOffset] = useState(GLOBAL_HEADER_HEIGHT);

    const { repoStatus = 0 } = repositoryStatus || {}
    useEffect(() => {
        if (entitiesMenu) setShowMainMenu(true)
    }, [entitiesMenu])

    useEffect(() => {
        if (repoStatus) {
            // 35px is the value set with-repository-banner
            const addValue = repoStatus ? 35 : 0
            setTopOffset(GLOBAL_HEADER_HEIGHT + addValue);
        }
    }, [repoStatus])

    const location = useLocation();
    const isOnDataRoute = useMemo(() => {
        if (!leftMenuStaticLinks?.length) return false;
        const currentPath = location.pathname;

        return leftMenuStaticLinks.some((entry) =>
            (entry.nestedLinks || []).some((link) => {
                const linkPath = link.to?.split("?")[0];
                const paths = link.matchPaths || (linkPath ? [linkPath] : []);
                return paths.some(
                    (p) => currentPath === p || currentPath.startsWith(p + "/")
                );
            })
        );
    }, [leftMenuStaticLinks, location.pathname]);
    return (
        <GlobalLayout {...globalLayoutProps}>
            <SovosBox
                sx={
                    hasCustomHeader
                        ? {
                            "& .sovosPageTitleBar": { display: "none" },
                            "& .sovosPageLayout > header": { borderBottom: "none" },
                        }
                        : undefined
                }
            >
            <SovosPageLayout
                className={repoStatus ? `${styles["with-repository-banner"] || ""}` : ""}
                pageTitle={hasCustomHeader ? "" : title?.toString() || ""}
                titleBarActions={hasCustomHeader ? undefined : titleBarActions}
            >
                <RepositoryStatus modules={modules} />
                <SovosPageContentGeneric
                    sx={{
                        padding: "0 !important",
                        marginLeft: (showMainMenu || menuEntries?.length) && isOnDataRoute ? "0" : "24px",
                        marginRight: "24px",
                        height: "100%",
                        paddingTop: hasHeroBanner ? "49px !important" : "none"
                    }}
                >
                    {
                        isLoadingContent(fetch) ? (
                            <SovosBox
                                sx={{
                                    flex: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <SovosCircularProgress aria-label="Loading" />
                            </SovosBox>
                        ) : (
                            <>
                                {!hasCustomHeader && (
                                    <SovosBox sx={{
                                        position: "absolute",
                                        top: topOffset,
                                        left: 0,
                                        right: 0,
                                        overflowX: "hidden",
                                    }}>
                                        <Connect to={["search", "downloading"]}>
                                            {({ downloading }) => {
                                                const inlineHeaderProperties = Array.isArray(headerProps.headerComponents)
                                                    ? headerProps.headerComponents.filter((item) => item?.inline)
                                                    : [];
                                                const renderedInlineHeaderComponents = inlineHeaderProperties.map(
                                                    headerComponentsMapper(downloading),
                                                );
                                                // Repository renders inline header components inside RepositoryTabs row,
                                                // so the global absolute bar must not duplicate them here.
                                                const shouldRenderInlineHeaderComponents =
                                                    hasNewNavigation &&
                                                    !restHeaderProps.isRepository &&
                                                    renderedInlineHeaderComponents.length > 0;

                                                if (!shouldRenderInlineHeaderComponents) {
                                                    return (
                                                        <FileInformationSelection
                                                            {...restHeaderProps}
                                                            downloading={downloading}
                                                            i18n={i18n}
                                                            hasNewNavigation={hasNewNavigation}
                                                            headerComponents={null}
                                                        />
                                                    );
                                                }

                                                return (
                                                    <SovosBox
                                                        sx={{
                                                            alignItems: "stretch",
                                                            borderBottom: "1px solid var(--sovos-border-color)",
                                                            display: "flex",
                                                            gap: "8px",
                                                            overflowX: "auto",
                                                            [`& [class*="FileInformationSelection_toolbar-container"]`]: {
                                                                borderBottom: 0,
                                                                marginLeft: 0,
                                                                marginRight: 0,
                                                            },
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <FileInformationSelection
                                                            {...restHeaderProps}
                                                            downloading={downloading}
                                                            i18n={i18n}
                                                            hasNewNavigation={hasNewNavigation}
                                                            headerComponents={null}
                                                        />
                                                        <SovosBox
                                                            sx={{
                                                                alignItems: "center",
                                                                display: "flex",
                                                                flexShrink: 0,
                                                                gap: "8px",
                                                                height: "100%",
                                                                justifyContent: "center",
                                                                minHeight: "48px",
                                                                minWidth: "220px",
                                                                pr: 3,
                                                            }}
                                                        >
                                                            {renderedInlineHeaderComponents.map((component, index) => (
                                                                <React.Fragment key={`header-component-${index}`}>
                                                                    {component}
                                                                </React.Fragment>
                                                            ))}
                                                        </SovosBox>
                                                    </SovosBox>
                                                );
                                            }}
                                        </Connect>
                                    </SovosBox>
                                )}
                                {fetch.activity && (
                                    <LoadingIndicator className={styles["loading-indicator"] || ""} />
                                )}
                                {
                                    <SovosBox
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            height: "100%",
                                            width: "100%",
                                        }}
                                    >
                                        {(showMainMenu || menuEntries?.length) && isOnDataRoute ? (
                                            <NewNavigationMenu
                                                menuEntries={menuEntries}
                                                history={history}
                                            />
                                        ) : null}
                                        {!entitiesMenu ? (
                                            <SovosBox sx={{ flex: 1, overflowX: "hidden", overflowY: "auto" }}>
                                                <>
                                                    {hasCustomHeader && customHeader}
                                                    {children}
                                                    {route?.routes?.length > 1 && (
                                                        <MainTabs
                                                            className={styles["tabs"]}
                                                            routes={route.routes}
                                                            params={matchParams}
                                                        />
                                                    )}
                                                    {renderRoutes(route.routes)}
                                                </>
                                            </SovosBox>
                                        ) : (
                                            <SovosBox
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "100%",
                                                    width: "100%",
                                                    padding: "48px",
                                                }}
                                            >
                                                <SovosTypography variant="body1" sx={{ color: "text.secondary" }}>
                                                    {i18n`Select a table from the menu to view its data.`}
                                                </SovosTypography>
                                            </SovosBox>
                                        )
                                        }
                                    </SovosBox>
                                }
                            </>
                        )
                    }
                </SovosPageContentGeneric>
            </SovosPageLayout>
            </SovosBox>
        </GlobalLayout >
    );
};

export const useControllerInitialization = (props) => {
    const { pushModal, modules, user, fetch, menu, match, route, location, history, reload, modulePrefix: staticGenericPrefix, hasHeroBanner = false, hideNewMenu = false } =
        props;

    const { params: rawMatchParams } = match || {};
    const { projectId, locale = "en" } = rawMatchParams;
    const modulePrefix = rawMatchParams.modulePrefix || staticGenericPrefix;
    const matchParams = {
        ...rawMatchParams,
        ...(modulePrefix ? { modulePrefix } : {}),
    };

    const { results: fetchResults, status: fetchStatus } = fetch || {};

    const defaultContext = (match?.url || "").match("/repository/") ? "repository" : "";
    const [appContext, setAppContext] = useState(defaultContext);
    const auth = useAuth();

    useEffect(() => {
        if ((match?.url || "").match("/repository/")) {
            setAppContext("repository");
        } else {
            setAppContext("");
        }
    }, [match]);

    const userInformation = userSessionInfo(user);
    const i18n = I18n.use(locale);

    return {
        // Original props
        pushModal,
        modules,
        user,
        fetch,
        menu,
        match,
        route,
        location,
        history,
        reload,
        // Extracted values
        matchParams,
        projectId,
        modulePrefix,
        locale,
        fetchResults,
        fetchStatus,
        // State and hooks
        appContext,
        setAppContext,
        auth,
        userInformation,
        i18n,
        hasHeroBanner,
        hideNewMenu
    };
};

export const organizationAndProjectSelection = ({
    fetchResults,
    fetchStatus,
    component: Component,
    matchParams,
    props,
    i18n,
    locale,
    fiscalYear,
    importId,
    projectId,
    viewMode,
    route
}) => {
    const { staticParams = {} } = route || {};
    const modifiedParams = { ...matchParams, staticParams }
    const { menuOrganizationProject = [] } = mapProperties(
        {
            menuOrganizationProject: "query(0).list",
        },
        fetchResults,
        fetchStatus,
        Component.queries(modifiedParams),
        props,
        modifiedParams,
        i18n,
        locale,
    );

    const paramsForQueries = { ...matchParams, ...(viewMode && { viewMode }) };
    const componentQueries = Component?.queries ? Component.queries(paramsForQueries) : [];
    const { organizationProjects = {}, queryStatus } = mapProperties(
        {
            organizationProjects: "query(1)",
            queryStatus: "status(1)",
        },
        fetchResults,
        fetchStatus,
        componentQueries,
        props,
        modifiedParams,
        i18n,
        locale,
    );

    const { fileTypeModulesByProject = [] } = mapProperties(
        {
            fileTypeModulesByProject: "query(5).list",
        },
        fetchResults,
        fetchStatus,
        Component.queries(modifiedParams),
        props,
        modifiedParams,
        i18n,
        locale,
    );

    const { result: { hasSource, hasLegal } = {} } = mapProperties(
        {
            result: "query(4)",
        },
        fetchResults,
        fetchStatus,
        Component.queries(modifiedParams),
        props,
        modifiedParams,
        i18n,
        locale,
    );

    const project = organizationProjects
        ? (organizationProjects.projects || []).find(({ id }) => String(id) === String(projectId)) || {
            name: "",
        }
        : { name: "" };

    const { fiscalYears: projectFiscalYears } = project || {};

    const fiscalYears = Object.keys(projectFiscalYears || []);

    if (!fiscalYear && project && projectFiscalYears) {
        fiscalYear = fiscalYears.length > 0 ? Math.max(...fiscalYears) : "";
    }

    const fiscalYearsWithImportIds = projectFiscalYears || {};
    const importIdsFromUrlFiscalYear = viewMode
        ? fiscalYearsWithImportIds[fiscalYear]?.[viewMode]
        : fiscalYearsWithImportIds[fiscalYear];

    if (!importId && importIdsFromUrlFiscalYear?.length) {
        const [maxImportId] = importIdsFromUrlFiscalYear;
        importId = maxImportId?.id;
    }

    return {
        menuOrganizationProject,
        organizationProjects,
        queryStatus,
        projectFiscalYears,
        project,
        fiscalYears,
        fiscalYearsWithImportIds,
        importIdsFromUrlFiscalYear,
        fiscalYear,
        importId,
        fileTypeModulesByProject,
        hasSource,
        hasLegal
    };
};

export const buildGenericMenu = (
    modules,
    fetchResults,
    locale,
    fiscalYear,
    projectId,
    importId,
    project,
    location,
    matchParams,
    route,
    viewMode,
    fileTypeModulesByProject
) => {
    const hasNewNavigation = hasModule(modules, "new_navigation");
    const queriesForMenu = filteredQueriesByModulesForMenu(modules);
    const navData = mapPropertiesForMenu(
        queriesForMenu,
        fetchResults,
        locale,
        fiscalYear,
        projectId,
        importId,
        viewMode,
        fileTypeModulesByProject,
        hasNewNavigation
    );

    const firstModuleFromProject = getFirstModuleOfArray(modules);
    const moduleConfigs = project
        ? (project.modules || []).find(({ name }) => name === firstModuleFromProject)
        : undefined;
    const importIdToUse =
        moduleConfigs && moduleConfigs.navigation_by_import_id ? importId : "full";

    const params = {
        ...(parse(location.search) || {}),
        ...(matchParams || {}),
    };

    const routeQueries = (route.queries && route.queries(params)) || [];

    return { navData, importIdToUse, routeQueries, params, firstModuleFromProject };
};

export const buildDisplayComponents = (route, getLayout) => {
    let displayComponents = [];

    displayComponents.push(...route.components);

    if (getLayout.length > 0 && route && route.isOverview) {
        displayComponents.push(...getLayout);
    }

    return displayComponents;
};

export const buildHeaderComponents = (
    route,
    fetchResults,
    fetchStatus,
    routeQueries,
    props,
    params,
    i18n,
    locale,
) => {
    return Array.isArray(route?.headerComponents)
        ? route.headerComponents.map((headerProperties) => {
            const component = headerProperties.component;
            const headerComponentParsedProps = mapProperties(
                headerProperties.props,
                fetchResults,
                fetchStatus,
                routeQueries,
                props,
                params,
                i18n,
                locale,
            );
            return {
                Component: component,
                props: headerComponentParsedProps,
                inline: !!headerProperties.inline,
            };
        })
        : [];
};

export const headerTitle = (
    route,
    fetchResults,
    fetchStatus,
    routeQueries,
    props,
    params,
    i18n,
    locale,
    fiscalYear,
    importId,
) => {
    return mapProperties(
        { title: route.title },
        fetchResults,
        fetchStatus,
        routeQueries,
        props,
        { ...params, fiscalYear, importId },
        i18n,
        locale,
    ).title;
};
export const headerFileTypesPresent = (
    route,
    fetchResults,
    fetchStatus,
    routeQueries,
    props,
    params,
    i18n,
    locale,
    fiscalYear,
    importId,
    projectId
) => {
    // Get data by default
    const {
        dataFilesPresent = { hasSource: false, hasLegal: false },
    } = getQueryResultsArray(fetchResults, [
        {
            resultName: "dataFilesPresent",
            queryName: `${locale}_data_files_types_present_projectId_${projectId}`,
        },
    ]);
    return mapProperties(
        { hasSource: route.hasSource || dataFilesPresent?.hasSource, hasLegal: route.hasLegal || dataFilesPresent?.hasLegal },
        fetchResults,
        fetchStatus,
        routeQueries,
        props,
        { ...params, fiscalYear, importId },
        i18n,
        locale,
    );
};

export const getDownloadableQueries = (matchRoutes, route, location, params) => {
    const branch = matchRoutes([route, ...(route.routes || [])], location.pathname);

    const branchQueries = branch.reduce((allQueries, { route }) => {
        const innerQueries = route.queries ? route.queries(params) : [];
        allQueries = [...innerQueries];
        return allQueries;
    }, []);

    const downloadableQueries = branchQueries?.filter(({ downloadable }) => downloadable);

    return downloadableQueries;
};

export const generateNavigation = ({
    modules,
    asideRepositoryNavigationByModule,
    route,
    fetchResults,
    fetchStatus,
    component: Component,
    params,
    fiscalYear,
    importId,
    props,
    navData,
    i18n,
    locale,
}) => {
    // const { viewMode, navigation } = navData || {}
    const repositoryNavigation = filteredNavigationByModulesForNestedLinks(
        modules || [],
        asideRepositoryNavigationByModule,
    );

    const _navigation = (route.navigation || []).map((item) => {
        if (item?.name === "label(Repository)") {
            delete item.to;
            item.navigation = [...repositoryNavigation];
        }

        return item;
    });

    const mappedNavigation = mapProperties(
        { navigation: _navigation },
        fetchResults,
        fetchStatus,
        Component.queries({ ...params, fiscalYear, importId }),
        {
            ...props,
            ...navData,
        },
        { ...params, fiscalYear, importId },
        i18n,
        locale,
    )
    const updatedNavigation = (mappedNavigation?.navigation || []).map((elem) => {
        const getNavigationChildren = (element) => {
            if (Array.isArray(element?.navigation)) return element.navigation;
            if (Array.isArray(element?.navigation?.navigation)) return element.navigation.navigation;
            return [];
        };
        const navChildren = getNavigationChildren(elem);

        const viewMode = navChildren
            .find(child => child.navigation?.viewMode)
            ?.navigation?.viewMode;

        const cleanedNavigation = navChildren.map((child) => {
            if (child.navigation?.viewMode) {
                const { viewMode: _, ...restNavigation } = child.navigation;
                return { ...child, navigation: restNavigation };
            }
            return child;
        });

        return viewMode
            ? { ...elem, viewMode, navigation: cleanedNavigation }
            : { ...elem, navigation: cleanedNavigation };
    });

    return { ...mappedNavigation, navigation: updatedNavigation };
};

export const buildNavProps = (
    buildStaticLinks,
    navigation,
    history,
    matchParams,
    fiscalYear,
    importId,
    i18n,
    menuOrganizationProject,
    projectId,
    cleanPropertiesNestedInMenu,
    locale,
    proxy,
    params,
    userInformation,
    modules,
    viewMode = "source",
) => {
    // Check if project has new_navigation module
    const hasNewNavigation = hasModule(modules, "new_navigation");
    const staticLinks = buildStaticLinks(
        navigation,
        history,
        { ...matchParams, fiscalYear, importId },
        i18n,
        hasNewNavigation,
    );

    const organizationSelectedInMenu = (menuOrganizationProject || []).find(({ nestedAccounts }) =>
        (nestedAccounts || []).some(({ id }) => id === projectId),
    );

    const {
        accounts: fullOrganizationsWithProjects,
        selectedAccount: selectedOrganizationWithProjects,
    } = cleanPropertiesNestedInMenu(menuOrganizationProject, organizationSelectedInMenu);


    // If new_navigation is active, filter out raw_data and custom_templates from top level
    // (they appear in the Data submenu instead). Legacy mode keeps them in top level.
    const filteredStaticLinks = (staticLinks || []).filter((item) => {
        if (!hasNewNavigation) {
            return true; // Legacy mode: keep all items
        }

        // New navigation mode: filter out raw_data and custom_templates
        const toPath = item.to || "";
        const itemId = item.id || "";
        const itemLabel = item.label || "";
        const itemName = item.name || "";

        // Check by path pattern
        const isRawData = toPath.includes("/raw_data");
        const isCustomTemplates = toPath.includes("/custom_templates");

        // Also check by ID/label/name pattern (for safety)
        const isRawDataById = itemId.includes("RAW DATA") || itemLabel.includes("RAW DATA") || itemName.includes("RAW DATA");
        const isCustomTemplatesById = itemId.includes("Custom Templates Raw Data") || itemLabel.includes("Custom Templates Raw Data") || itemName.includes("Custom Templates Raw Data");

        // Filter out if it's raw_data or custom_templates
        if ((isRawData || isRawDataById) || (isCustomTemplates || isCustomTemplatesById)) {
            return false;
        }
        return true;
    });

    const dedupedStaticLinks = dedupeHydratedOverviewStaticLinks(
        filteredStaticLinks,
        hasNewNavigation,
    );

    const indexToInsertDefaultSubMenu = dedupedStaticLinks.findIndex((item) => item.useInMenuTreeList);
    const defaultSubMenuStaticLinks = {
        id: "Data_0",
        label: "Data",
        key: "data",
        to: "",
        icon: StackedLineChart,
        useInMenuTreeList: true,
        nestedLinks: [
            {
                id: "StructuredData_0",
                content: "Structured Data",
                label: "Structured Data",
                key: "data",
                to: `/${locale}/${projectId}/${fiscalYear}/${importId}/structured_data?viewMode=${viewMode}`,
                matchPaths: [
                    `/${locale}/${projectId}/${fiscalYear}/${importId}/structured_data`,
                    `/${locale}/${projectId}/${fiscalYear}/${importId}/master_data`,
                    `/${locale}/${projectId}/${fiscalYear}/${importId}/transactional_data`,
                ],
                action: () => {
                    history.push(`/${locale}/${projectId}/${fiscalYear}/${importId}/structured_data?viewMode=${viewMode}`);
                }
            },
            (hasModule(modules, "raw_data") ? {
                id: "RawData_0",
                content: "Raw Data",
                label: "Raw Data",
                key: "data",
                to: `/${locale}/${projectId}/${fiscalYear}/${importId}/raw_data?viewMode=${viewMode}`,
                // Match both landing URL and module-prefixed URLs like /.../saft_pt/raw_data/...
                matchFn: (path) => {
                    const base = `/${locale}/${projectId}/${fiscalYear}/${importId}/`;
                    return path.startsWith(base) && path.includes("/raw_data");
                },
                action: () => {
                    history.push(`/${locale}/${projectId}/${fiscalYear}/${importId}/raw_data?viewMode=${viewMode}`);
                }
            } : null),
            (hasModule(modules, "custom_templates") ? {
                id: "CustomData_0",
                content: "Custom Data",
                label: "Custom Data",
                key: "data",
                to: `/${locale}/${projectId}/${fiscalYear}/${importId}/custom_templates?viewMode=${viewMode}`,
                // Match both landing URL and module-prefixed URLs like /.../saft_pt/custom_templates/...
                matchFn: (path) => {
                    const base = `/${locale}/${projectId}/${fiscalYear}/${importId}/`;
                    return path.startsWith(base) && path.includes("/custom_templates");
                },
                action: () => {
                    history.push(`/${locale}/${projectId}/${fiscalYear}/${importId}/custom_templates?viewMode=${viewMode}`);
                }
            } : null)
        ].filter((elem) => elem)
    };

    const leftMenuStaticLinks = dedupedStaticLinks
        .filter(item => !item.useInMenuTreeList)
        .reduce((acc, item, index) => {
            if (index === indexToInsertDefaultSubMenu) {
                acc.push(defaultSubMenuStaticLinks);
            }
            acc.push(item);
            return acc;
        }, []);

    const menuToShow = hasNewNavigation ? leftMenuStaticLinks || [] : dedupedStaticLinks
    const navProps = BuildSovosNavProps(
        undefined,
        fullOrganizationsWithProjects,
        selectedOrganizationWithProjects,
        { locale, history, proxy, params: { ...params, fiscalYear, importId } },
        userInformation,
        menuToShow,
        projectId,
    );

    return { navProps, staticLinks: dedupedStaticLinks, leftMenuStaticLinks, hasNewNavigation };
};


export const NewNavigationMenu = ({
    menuEntries,
    history,
    viewMode,
    loading,
    flatList
}) => {

    const [isCollapsed, setIsCollapsed] = useState(() => {
        const saved = localStorage.getItem("mainMenuCollapsed");
        return saved ? JSON.parse(saved) : false;
    });
    const handleSetIsCollapsed = (value) => {
        const newValue = typeof value === "function" ? value(isCollapsed) : value;
        setIsCollapsed(newValue);
        localStorage.setItem("mainMenuCollapsed", JSON.stringify(newValue));
    };
    const resizeStartRef = useRef({ startX: 0, startWidth: 0 });
    const [panelWidth, setPanelWidth] = useState(() => {
        const saved = localStorage.getItem("mainMenuPanelWidth");
        return saved ? parseInt(saved, 10) : 300;
    });
    const [isResizing, setIsResizing] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isResizing) {
                const delta = e.clientX - resizeStartRef.current.startX;
                const newWidth = resizeStartRef.current.startWidth + delta;
                if (newWidth >= 180) {
                    setPanelWidth(newWidth);
                    localStorage.setItem("mainMenuPanelWidth", newWidth.toString());
                }
            }
        };

        const handleMouseUp = () => {
            setIsResizing(false);
        };

        if (isResizing) {
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
        }

        return () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };
    }, [isResizing]);

    return (
        <SovosBox
            sx={{
                display: "flex",
                flexDirection: "column",
                flex: isCollapsed ? "0 0 50px" : `0 0 ${panelWidth}px`,
                width: isCollapsed ? "50px" : `${panelWidth}px`,
                height: "100%",
                minHeight: 0,
                transition: isCollapsed ? "flex 0.7s ease-in-out, opacity 0.7s ease-in-out" : "opacity 0.7s ease-in-out",
                opacity: isCollapsed ? 0.9 : 1,
                position: "relative",
                maxWidth: "70%"
            }}
        >
            <MainMenuContent
                menuProps={menuEntries}
                history={history}
                isCollapsed={isCollapsed}
                setIsCollapsed={handleSetIsCollapsed}
                viewMode={viewMode}
                loading={loading}
                flatList={flatList}
            />
            {!isCollapsed && (
                <>
                    <SovosDivider
                        orientation="vertical"
                        sx={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                            height: "100%",
                            margin: 0
                        }}
                    />
                    <SovosBox
                        sx={{
                            position: "absolute",
                            right: -2,
                            top: 0,
                            height: "100%",
                            width: "4px",
                            cursor: "col-resize",
                            backgroundColor: "transparent",
                            transition: "background-color 0.2s",
                            "&:hover": {
                                backgroundColor: "grey.400",
                                width: "6px",
                                right: -3
                            },
                            zIndex: 1000
                        }}
                        onMouseDown={(e) => {
                            setIsResizing(true);
                            resizeStartRef.current = {
                                startX: e.clientX,
                                startWidth: panelWidth
                            };
                            e.preventDefault();
                        }}
                    />
                </>
            )}
        </SovosBox>
    )
}